import { render, staticRenderFns } from "./tabulacao-supervisor.vue?vue&type=template&id=40639670&scoped=true"
import script from "./tabulacao-supervisor.vue?vue&type=script&lang=js"
export * from "./tabulacao-supervisor.vue?vue&type=script&lang=js"
import style0 from "./tabulacao-supervisor.vue?vue&type=style&index=0&id=40639670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40639670",
  null
  
)

export default component.exports